import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { Spinner } from '../components/primitives';

/**
 * Target of the Cognito redirect after sign-in. AuthProvider processes the
 * code exchange automatically (see onSigninCallback in main.tsx); this page
 * only waits and surfaces failures as the access-denied page.
 */
export function AuthCallback() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    // Cognito can bounce back with an error (e.g. rejected by the domain trigger).
    const cognitoError = params.get('error_description') ?? params.get('error');
    if (cognitoError) {
      navigate(`/access-denied?reason=${encodeURIComponent(cognitoError)}`, { replace: true });
    }
  }, [params, navigate]);

  useEffect(() => {
    if (auth.error) {
      navigate(`/access-denied?reason=${encodeURIComponent(auth.error.message)}`, { replace: true });
    }
  }, [auth.error, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <Spinner label="Completing sign-in" />
    </div>
  );
}
